import tags from "../data/global/tags.json"

interface TagInfo {
    color: string
    label: string
}

export const getTagInfoById = (id: number): TagInfo | undefined  => tags.tags.find(tag => tag.id === id)
